.app-view
  div(data-hook="sidebar")
  main(role="main")
  div(data-hook="transit-bar")
